import { UTM_DEFAULT_CAMPAIGN, UTM_DEFAULT_MEDIUM, UTM_DEFAULT_SOURCE } from "./utmParams";

// Función para mapear datos del formulario al formato de Tecnóm
export const mapFormDataToTecnom = (formData) => {
  const currentDate = new Date().toISOString();

  // Mapear el tipo de operación según la selección del usuario
  // tipoPlan puede ser "plan" o "venta directa" o similar
  const operationType =
    formData.tipoPlan === "plan"
      ? "Plan de Ahorro"
      : formData.tipoPlan === "venta directa" || formData.tipoPlan === "directa"
      ? "Venta Directa"
      : formData.tipoPlan || "Consulta";

  const origin = formData.utm_source || UTM_DEFAULT_SOURCE;

  // Suborigen hardcodeado como "web"
  const suborigen = "web";

  // Limpiar el teléfono (remover espacios)
  const cleanPhone = formData.phone ? formData.phone.replace(/\s+/g, "") : "";

  // Construir la descripción del vehículo para comments
  let vehicleDescription = "";
  if (formData.vehicle) {
    vehicleDescription = formData.vehicle;
  } else if (formData.vModelo) {
    vehicleDescription = `${formData.brand || ""} ${formData.vModelo}`.trim();
    if (formData.vVersion) {
      vehicleDescription += ` ${formData.vVersion}`;
    }
  }

  // Construir el objeto vehicle solo si tenemos datos de identificación válidos
  // La API requiere al menos registration_plate o vin_vis
  let vehicle = null;

  // Si tenemos patente o VIN, construimos el objeto vehicle
  if (formData.registration_plate || formData.vin_vis) {
    vehicle = {
      ...(formData.registration_plate && {
        registration_plate: {
          value: formData.registration_plate,
        },
      }),
      ...(formData.vin_vis && {
        vin_vis: {
          value: formData.vin_vis,
        },
      }),
      ...(vehicleDescription && { description: vehicleDescription }),
      ...(formData.model_make_code && { model_make_code: formData.model_make_code }),
      ...(formData.year && { year: formData.year }),
    };
  }

  const medioTrim = formData.medio && String(formData.medio).trim();
  const mediumFromUtm = formData.utm_medium && String(formData.utm_medium).trim();
  const medium = mediumFromUtm || UTM_DEFAULT_MEDIUM;

  let commentsBody = `${formData.comments || ""}${formData.comments ? " - " : ""}Tipo de operación: ${operationType}${
    vehicleDescription ? ` - Vehículo: ${vehicleDescription}` : ""
  }`;
  if (medioTrim) {
    commentsBody += ` - Canal preferido: ${medioTrim}`;
  }

  return {
    contact: {
      full_name: formData.name || "",
      email: {
        value: formData.email || "",
        type: "work",
      },
      phone: {
        value: cleanPhone,
        type: "work",
        country_code: "AR",
      },
      mobile_phone: {
        value: cleanPhone,
        type: "work",
        country_code: "AR",
      },
    },
    product: formData.brand || "JEEP",
    comments: commentsBody,
    medium,
    origin: origin,
    sub_origin: suborigen,
    campaign: formData.utm_campaign || formData.desolChannel || formData.campaign || UTM_DEFAULT_CAMPAIGN,
    requested_at: currentDate,
    first_contacted_at: currentDate,
    ...(vehicle && { vehicle }),
  };
};

